import { Suspense } from "react";
import { Route } from "react-router-dom";
import Login from "../../pages/Login/Login";
import RecoverPassword from "../../pages/RecoverPassword/RecoverPassword";
import VerificationCode from "../../pages/Verificationcode/Verificationcode";
import PageNotFound from "../../pages/PageNotFound/PageNotFound";

const RoutesGuest = () => {
    return (
        <>
            <Route
                path="/login"
                element={
                    <Suspense fallback={<div>Skeleton</div>}>
                        <Login />
                    </Suspense>
                }
            />
            <Route
                path="/recover-password"
                element={
                    <Suspense fallback={<div>Skeleton</div>}>
                        <RecoverPassword />
                    </Suspense>
                }
            />
            <Route
                path="/verification-code"
                element={
                    <Suspense fallback={<div>Skeleton</div>}>
                        <VerificationCode />
                    </Suspense>
                }
            />

            <Route path="*" element={<PageNotFound />} />
        </>
    );
};
export default RoutesGuest;
